import { PATH_HOME_URL, PATH_LOGIN_URL } from 'constants/Paths';
import { AlertContext } from 'context/AlertContext';
import React, { useContext, lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { PrivateRoute } from 'RouteConfig/PrivateRoute';
import AlertContainer from 'WebMDS/dist/AlertContainer';

const Login = lazy(() => import('containers/Login/Login'));
const RouterList = lazy(() => import('RouteConfig/RouterList'));
const AppLayout = ({ token }) => {
  const { alerts, removeAlert } = useContext(AlertContext);
  return (
    <>
      <AlertContainer alerts={alerts} closeFunction={removeAlert} />
      {token !== '' && (
        <Suspense fallback={<div>Loading...</div>}>
          <Switch>
            <Route path={PATH_LOGIN_URL} component={Login} />
            <PrivateRoute path={PATH_HOME_URL} component={RouterList} />
          </Switch>
        </Suspense>
      )}
    </>
  );
};

export default AppLayout;
